import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReadMoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"read_more"}/>
}
